import { ComparisonDisclaimer } from '@/components/pet/ComparisonDisclaimer';
import GoodToKnowSection from '@/components/pet/GoodToKnowSection/GoodToKnowSection';
import { CompareHero } from '@/components/pet/compare/CompareHero';
import { CompareReviews } from '@/components/pet/compare/CompareReviews';
import { getGoodToKnowInfo } from '@/components/pet/compare/GoodToKnowInfo';
import { CompareTable } from '@/components/shared/CompareTable';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { config } from '@/pageConfig/pet/compare/us/pet-compare';
import { PET_LANDING_PAGE } from '@/utils/productAdaPages';
import { PRODUCT_PET } from '@/utils/products';
import { Box } from '@lemonade-hq/cdk';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import Script from 'next/script';
import { useEffect, useState } from 'react';

export default function DogsPage() {
  const [showTrustpilot, setShowTrustpilot] = useState(false);
  const { trackEvent } = useAnalyticsContext();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => trackEvent('pet_compare_landing_page_variant.viewed'), []);

  return (
    <Layout
      headerActions={config.layout.headerActions}
      product={PRODUCT_PET}
      page={PET_LANDING_PAGE}
      productType={PRODUCT_PET}
      showDisclaimer={false}
      additionalFooterContent={<ComparisonDisclaimer />}
    >
      <SEO {...config.seo} />
      <Script
        type="text/javascript"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
        onLoad={() => setShowTrustpilot(true)}
      />
      <PageWrapper>
        <CompareHero {...config.hero} />
        <Box mt={[0, 30]}>
          <CompareTable {...config.compareTable} darkBackground />
        </Box>
        <CompareReviews show={showTrustpilot} {...config.compareReviews} />
        <GoodToKnowSection bg="dark" data={getGoodToKnowInfo} />
      </PageWrapper>
    </Layout>
  );
}
